import { render, staticRenderFns } from "./EventTemplateDropdownMenu.vue?vue&type=template&id=5c6e6641&scoped=true&"
import script from "./EventTemplateDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./EventTemplateDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./EventTemplateDropdownMenu.vue?vue&type=style&index=0&id=5c6e6641&lang=scss&scoped=true&"
import style1 from "./EventTemplateDropdownMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e6641",
  null
  
)

export default component.exports